/* @flow */
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getDocTaskApi
} from '../../apiUtils/api';
import type { 
    InputFormData,SubmitPayload,
    Dispatch,EditFormData,ReducerState
} from './flowTypes'
import { transformFormDataToEditMode } from './editFormData'
import { 
    getDocExtractedData,getReviewOutcome
} from './submitFormData'

export const getTaskData=(gorgon:ReducerState, jwt:string,taskAcceptedInfoId: string)=>{
    return (dispatch:Dispatch) => getDocTaskApi(jwt,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.EDIT_KRATOS_EC_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformFormDataToEditMode(data,gorgon)
            dispatch({
                type: actionTypes.EDIT_KRATOS_EC_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['review_questions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.EDIT_KRATOS_EC_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const docSubmissionCompleted = () => {
    return { type: actionTypes.KRATOS_EC_DOC_SUBMITTED_COMPLETED };
}

export const docSubmission = (
    jwt:string,taskAcceptedInfoId:number,formData:InputFormData,
    reviewQuestions: Array<any>
    )=>{

    let payload:SubmitPayload = {
        isDocNotLoad: formData.isDocNotLoad?formData.isDocNotLoad:false,
        isDocInvalid: formData.isDocInvalid?formData.isDocInvalid:false,
        taskAcceptedInfoId:taskAcceptedInfoId
    }
    
    if (!formData.isDocNotLoad && !formData.isDocInvalid ){
        payload.docExtractedData=getDocExtractedData(formData)
    }
    if (reviewQuestions.length > 0 ){
        payload.docReviewOutcome=getReviewOutcome(formData,reviewQuestions)
    }
    
    return (dispatch:Dispatch) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.KRATOS_EC_DOC_SUBMIT_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.KRATOS_EC_DOC_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.KRATOS_EC_DOC_SUBMIT_ERROR, error: err});
    })
}


// WEBPACK FOOTER //
// ./src/redux/kratosec/actions.js